import { createContext, useContext } from "react";
import { noop } from "../../../helpers/general";

export interface UploadReceiptsActionContext {
    refreshTransactions: () => void;
}

export const uploadReceiptsActionContext =
    createContext<UploadReceiptsActionContext>({
        refreshTransactions: noop,
    });

export function useUploadReceiptsActionContext() {
    return useContext(uploadReceiptsActionContext);
}
